module.exports = __webpack_public_path__ + "img/937.b6381c1e.png";